export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services',
      conseil: 'Conseil',
      accompagnement: 'Accompagnement',
      aiSolutions: 'Solutions IA',
      partnerships: 'Partenariats',
      training: 'Formation',
      recruitment: 'Recrutement',
      about: 'À Propos',
      contact: 'Contact'
    },
    home: {
      newsText: "🚀 Innovation • Excellence • Transformation Digitale • IA & Solutions Avancées • Accompagnement Personnalisé • Expertise Certifiée",
      heroTitle: 'Excellence en',
      heroBadge: "Innovation & Excellence",
      statsTitle: "Nos Chiffres Clés",
      heroTitleHighlight: 'Performance Industrielle',
      heroSubtitle: 'Des solutions sur-mesure pour transformer votre entreprise',
      stat1: 'Projets Réalisés',
      stat2: 'Clients Satisfaits',
      stat3: 'Années d\'Expérience',
      stat4: 'Taux de Satisfaction',
      expertiseTitle: 'Nos Domaines d\'Expertise',
      expertiseSubtitle: 'Des solutions complètes et modulables adaptées à vos besoins spécifiques',
      service1Title: 'Conseil Stratégique',
      service1Desc: 'Analyse approfondie et recommandations pour optimiser votre performance industrielle',
      service2Title: 'Accompagnement Opérationnel',
      service2Desc: 'Intégration dans vos équipes pour mener à bien vos projets de transformation',
      service3Title: 'Solutions IA',
      service3Desc: 'Intégration de l\'intelligence artificielle dans vos processus de production',
      service4Title: 'Partenariats Internationaux',
      service4Desc: 'Développement de partenariats industriels Maroc-International',
      ctaTitle: 'Prêt à Transformer Votre Performance ?',
      ctaDescription: 'Nos experts sont à votre disposition pour analyser vos besoins et vous proposer des solutions sur-mesure adaptées à vos enjeux industriels.',
      ctaFeature1: 'Diagnostic gratuit de votre situation',
      ctaFeature2: 'Solutions personnalisées et innovantes',
      ctaFeature3: 'Accompagnement de A à Z par nos experts',
      ctaButton: 'Démarrer votre projet',
      supportLabel: 'Support Client'
    },
    services: {
      pageTitle: 'Nos Services',
      pageSubtitle: 'Une offre complète et modulable adaptée à vos besoins spécifiques',
      learnMore: 'En savoir plus',
       conseil: {
    description: 'Nos missions de conseil incluent l\'analyse approfondie de vos processus, l\'identification des leviers de performance, et la formulation de recommandations stratégiques pour optimiser votre production.',
    feature1: 'Simplification de situations complexes',
    feature2: 'Recommandations et propositions stratégiques',
    feature3: 'Études approfondies et conception de projets',
    feature4: 'Identification des leviers de performance',
    feature5: 'Analyse des pratiques concurrentielles'
  },
  accompagnement: {
    description: 'Nos consultants s\'intègrent dans vos équipes pour vous accompagner dans la mise en œuvre de vos projets industriels, du benchmarking à la supervision des opérations.',
    feature1: 'Intégration complète dans vos équipes',
    feature2: 'Supervision et réalisation de missions',
    feature3: 'Application de méthodologies éprouvées',
    feature4: 'Création et amélioration de standards',
    feature5: 'Passage de la vie projet à la vie série'
  },
  ai: {
    description: 'Collaboration avec des start-ups technologiques pour intégrer l\'intelligence artificielle dans vos méthodes industrielles et optimiser vos processus de production.',
    feature1: 'Agents méthodes assistés par IA',
    feature2: 'Outils de pilotage avancés',
    feature3: 'Projets innovants sur-mesure',
    feature4: 'Amélioration de l\'efficacité opérationnelle',
    feature5: 'Optimisation des décisions en temps réel'
  },
  partnerships: {
    description: 'Accompagnement en prospection internationale et facilitation de partenariats entre clients étrangers et industriels marocains, avec un focus sur la performance manufacturière.',
    feature1: 'Prospection internationale ciblée',
    feature2: 'Facilitation de partenariats Maroc-International',
    feature3: 'Focus sur la performance manufacturière',
    feature4: 'Mise en relation d\'industriels qualifiés',
    feature5: 'Accompagnement dans le développement'
  },
  training: {
  description: 'Programmes de formation sur-mesure pour développer les compétences de vos équipes et optimiser votre performance industrielle.',
  feature1: 'Méthodes, Process & Industrialisation',
  feature2: 'Production – Management d\'Atelier',
  feature3: 'Qualité & Amélioration Continue',
  feature4: 'Lean Manufacturing',
  feature5: 'Management & Organisation',
  feature6: 'Leadership & Management',
  feature7: 'Maintenance Industrielle & Fiabilité des Équipements',
  feature8: 'Compétences Techniques & Digitalisation',
  feature9: 'Soft Skills'
},
recruitment: {
  description: 'Solution complète d\'acquisition de talents dans les secteurs industriels avec une approche basée sur 4 piliers.',
  feature1: 'Compréhension du besoin client (compétences, niveau, contraintes)',
  feature2: 'Sélection par compétences techniques et comportementales',
  feature3: 'Évaluation réelle en environnement industriel',
  feature4: 'Intégration et accompagnement post-recrutement',
  feature5: 'Analyse du poste & profil recherché',
  feature6: 'Recherche & présélection'
}
    },
    conseil: {
      pageTitle: 'Conseil Stratégique',
      pageSubtitle: 'Expertise et recommandations pour optimiser votre performance industrielle',
      missionsTitle: 'Nos Missions de Conseil',
      missionsSubtitle: 'Un accompagnement personnalisé pour améliorer votre qualité, productivité et délais de fabrication',
      mission1: 'Simplifier une situation compliquée',
      mission2: 'Faire des recommandations ou propositions',
      mission3: 'Conduire une étude approfondie et concevoir un projet détaillé',
      mission4: 'Identifier les leviers de performance et les actions correctives',
      mission5: 'Effectuer une mission de terrain chez le client, suivie d\'une phase d\'analyse et de rédaction',
      mission6: 'Effectuer une analyse approfondie',
      mission7: 'Étudier les pratiques des concurrents',
      approachTitle: 'Notre Approche',
      approachSubtitle: 'Une méthodologie structurée pour des résultats mesurables',
      step1Title: 'Diagnostic',
      step1Desc: 'Analyse complète de votre situation actuelle et identification des opportunités d\'amélioration',
      step2Title: 'Recommandations',
      step2Desc: 'Propositions stratégiques basées sur les meilleures pratiques et adaptées à votre contexte',
      step3Title: 'Plan d\'action',
      step3Desc: 'Feuille de route détaillée avec priorités, ressources et indicateurs de performance',
      step4Title: 'Accompagnement',
      step4Desc: 'Suivi et support dans la mise en œuvre des recommandations pour garantir les résultats',
      closingTitle: 'Pour une Transformation Réussie',
      closingText: 'Nous proposons un accompagnement complet incluant le conseil stratégique, la formation de vos collaborateurs et le soutien opérationnel dans la mise en œuvre des projets.',
      cta: 'Contactez-nous'
    },
    accompagnement: {
      pageTitle: 'Accompagnement Opérationnel',
      pageSubtitle: 'Intégration dans vos équipes pour mener à bien vos projets de transformation',
      specialtiesTitle: 'Nos 3 Spécialités Complémentaires',
      specialtiesSubtitle: 'Une approche complète pour accompagner votre transformation industrielle',
      specialty1Title: 'Conseil',
      specialty1Desc: 'Analyse et recommandations stratégiques pour vos projets industriels',
      specialty2Title: 'Formation',
      specialty2Desc: 'Développement des compétences de vos équipes sur les meilleures pratiques',
      specialty3Title: 'Accompagnement Opérationnel',
      specialty3Desc: 'Présence terrain pour la mise en œuvre et le suivi des projets',
      missionsTitle: 'Nos Missions d\'Accompagnement',
      missionsSubtitle: 'Les consultants Texaconsult sont intégrés dans vos équipes et travaillent avec vous',
      mission1: 'Accompagner le client dans la mise en œuvre d\'un projet industriel',
      mission2: 'Intervenir à temps plein chez le client pour superviser ou réaliser une mission',
      mission3: 'Pallier un manque de ressources et/ou de compétences',
      mission4: 'Appliquer, améliorer ou créer des standards de production',
      mission5: 'Superviser les opérations et garantir la qualité',
      mission6: 'Mettre en œuvre des méthodologies éprouvées',
      mission7: 'Proposer des approches innovantes adaptées',
      phasesTitle: 'Du Projet à la Série',
      phasesSubtitle: 'Accompagnement dans toutes les phases de votre développement industriel',
      phase1Title: 'Vie Projet',
      phase1Desc: 'Accompagnement dans la phase de conception et de développement de vos projets industriels',
      phase2Title: 'Vie Série',
      phase2Desc: 'Support dans la transition vers la production en série et l\'optimisation continue',
      closingTitle: 'Méthodologies Éprouvées et Approches Innovantes',
      closingText: 'Du benchmarking à la supervision des opérations, nous appliquons des méthodologies qui ont fait leurs preuves tout en proposant des approches innovantes adaptées à vos besoins.',
      teamIntegration: "Intégration Équipe"
    },
    aiSolutions: {
      pageTitle: 'Solutions IA',
      pageSubtitle: 'Intégration de l\'intelligence artificielle dans vos méthodes industrielles',
      collaborationTitle: 'Collaboration avec des Start-ups Technologiques',
      collaborationSubtitle: 'Nous collaborons avec des start-ups innovantes pour intégrer les dernières technologies d\'IA dans vos processus de production',
      solution1Title: 'Agents Méthodes Assistés par IA',
      solution1Desc: 'Mise en place d\'agents intelligents pour optimiser vos processus de production et améliorer la prise de décision',
      solution2Title: 'Outils de Pilotage Avancés',
      solution2Desc: 'Développement d\'outils de monitoring et de pilotage en temps réel pour une meilleure visibilité opérationnelle',
      solution3Title: 'Projets Innovants Sur-Mesure',
      solution3Desc: 'Création de solutions IA personnalisées adaptées à vos défis industriels spécifiques',
      benefitsTitle: 'Bénéfices de l\'IA Industrielle',
      benefitsSubtitle: 'Amélioration de l\'efficacité, de la précision et de la rapidité des décisions opérationnelles',
      benefit1Title: 'Efficacité Accrue',
      benefit1Desc: 'Automatisation des tâches répétitives et optimisation des processus pour gagner en productivité',
      benefit2Title: 'Précision Améliorée',
      benefit2Desc: 'Réduction des erreurs et amélioration de la qualité grâce à l\'analyse prédictive',
      benefit3Title: 'Décisions Rapides',
      benefit3Desc: 'Accélération de la prise de décision grâce à l\'analyse de données en temps réel',
      optimizationTitle: 'Optimisation à Chaque Étape du Processus',
      optimizationText: 'Nos solutions d\'IA sont conçues pour améliorer l\'efficacité, la précision et la rapidité des décisions opérationnelles à chaque étape de votre processus industriel, de la conception à la production.',
      approachTitle: 'Une Approche Collaborative',
      approachText: 'En partenariat avec des start-ups technologiques de pointe, nous apportons les solutions d\'IA les plus innovantes et adaptées à vos besoins spécifiques. Notre approche collaborative garantit une intégration fluide et des résultats mesurables.',
      industrialAI: "IA Industrielle"
    },
    partnerships: {
      pageTitle: 'Partenariats Internationaux',
      pageSubtitle: 'Développement de partenariats industriels Maroc - International',
      servicesTitle: 'Nos Services de Partenariat',
      servicesSubtitle: 'Accompagnement en prospection internationale et facilitation de partenariats stratégiques',
      service1Title: 'Prospection Internationale',
      service1Desc: 'Identification et approche de partenaires potentiels à l\'international pour développer votre réseau',
      service2Title: 'Facilitation de Partenariats',
      service2Desc: 'Mise en relation entre clients étrangers et industriels marocains qualifiés',
      service3Title: 'Performance Manufacturière',
      service3Desc: 'Focus sur l\'excellence opérationnelle et l\'amélioration continue des processus',
      advantagesTitle: 'Nos Avantages',
      advantagesSubtitle: 'Pourquoi choisir Texaconsult pour vos partenariats internationaux',
      advantage1Title: 'Expertise Sectorielle',
      advantage1Desc: 'Connaissance approfondie des secteurs industriels et des marchés internationaux',
      advantage2Title: 'Réseau Étendu',
      advantage2Desc: 'Accès à un large réseau d\'industriels marocains et de clients internationaux',
      advantage3Title: 'Accompagnement Complet',
      advantage3Desc: 'Support dans toutes les étapes du développement de partenariat',
      processTitle: 'Notre Processus',
      processSubtitle: 'Une approche structurée pour des partenariats réussis',
      process1Title: 'Analyse des Besoins',
      process1Desc: 'Compréhension approfondie de vos objectifs et critères de partenariat',
      process2Title: 'Identification',
      process2Desc: 'Recherche et sélection de partenaires potentiels correspondant à vos besoins',
      process3Title: 'Mise en Relation',
      process3Desc: 'Organisation de rencontres et facilitation des échanges entre les parties',
      process4Title: 'Accompagnement',
      process4Desc: 'Support continu dans le développement et la pérennisation du partenariat',
      closingTitle: 'Focus sur la Performance Manufacturière',
      closingText: 'Nos partenariats sont axés sur l\'excellence opérationnelle et l\'amélioration continue des processus manufacturiers, garantissant des relations durables et mutuellement bénéfiques.',
      location: "Maroc - International"
    },
    training: {
  pageTitle: 'Formation Industrielle',
  pageSubtitle: 'Développement des compétences pour optimiser votre performance industrielle',
  domainsTitle: 'Nos Domaines de Formation',
  domainsSubtitle: 'Des programmes sur-mesure adaptés à vos besoins spécifiques',
  domain1Title: 'Méthodes, Process & Industrialisation',
  domain1Desc: 'Optimisation des processus et méthodes de production industrielle pour améliorer l\'efficacité et la productivité',
  domain2Title: 'Production – Management d\'Atelier',
  domain2Desc: 'Gestion et optimisation des ateliers de production avec focus sur le management opérationnel',
  domain3Title: 'Qualité & Amélioration Continue', 
  domain3Desc: 'Mise en place de systèmes qualité et démarches d\'amélioration continue pour une excellence durable',
  domain4Title: 'Lean Manufacturing',
  domain4Desc: 'Réduction des gaspillages et optimisation des flux pour une production plus efficiente',
  domain5Title: 'Management & Organisation',
  domain5Desc: 'Structuration et management des organisations industrielles pour une performance accrue',
  domain6Title: 'Leadership & Management',
  domain6Desc: 'Développement des compétences managériales et leadership pour piloter les équipes',
  domain7Title: 'Maintenance Industrielle & Fiabilité',
  domain7Desc: 'Optimisation de la maintenance et fiabilité des équipements pour réduire les temps d\'arrêt',
  domain8Title: 'Compétences Techniques & Digitalisation', 
  domain8Desc: 'Formation aux nouvelles technologies et digitalisation industrielle pour rester compétitif',
  domain9Title: 'Soft Skills',
  domain9Desc: 'Développement des compétences comportementales et relationnelles pour une collaboration efficace',
  approachTitle: 'Notre Approche Pédagogique',
  approachSubtitle: 'Une méthodologie adaptée aux enjeux industriels',
  step1Title: 'Analyse des Besoins',
  step1Desc: 'Évaluation approfondie de vos besoins en compétences et définition des objectifs de formation',
  step2Title: 'Conception Sur-Mesure',
  step2Desc: 'Développement de programmes adaptés à votre contexte industriel spécifique',
  step3Title: 'Animation Pratique',
  step3Desc: 'Formations animées par des experts terrain avec mise en situation réelle',
  step4Title: 'Évaluation & Suivi',
  step4Desc: 'Mesure des acquis et accompagnement dans la mise en œuvre des nouvelles compétences',
  closingTitle: 'Pour un Développement des Compétences Durable',
  closingText: 'Nous proposons des formations qui allient théorie et pratique, assurant un transfert de compétences effectif et mesurable dans votre environnement industriel.',
    "stats": {
    "domains": "Domaines",
    "trained": "Formés",
    "satisfaction": "Satisfaction",
    "yearsExp": "Années Exp."
  },
  "features": {
    "processOptimization": "Optimisation processus",
    "productionMethods": "Méthodes production",
    "industrialization": "Industrialisation",
    "workshopManagement": "Management atelier",
    "teamSupervision": "Supervision équipe",
    "operationalPerformance": "Performance opérationnelle",
    "qualitySystems": "Systèmes qualité",
    "continuousImprovement": "Amélioration continue",
    "performanceIndicators": "Indicateurs performance",
    "wasteReduction": "Réduction gaspillages",
    "flowOptimization": "Optimisation flux",
    "organizationStructure": "Structure organisation",
    "industrialManagement": "Gestion industrielle",
    "performanceSteering": "Pilotage performance",
    "leadership": "Leadership",
    "management": "Management",
    "skillsDevelopment": "Développement compétences"
  },
  "floatingBadge": {
    "title": "Experts Certifiés",
    "subtitle": "Formateurs industriels"
  },
  "ctaButton": "Demander un devis"
},

recruitment: {
  pageTitle: 'Recrutement Industriel',
  pageSubtitle: 'Solution complète d\'acquisition de talents pour l\'industrie',
  approachTitle: 'Notre Approche – 4 Piliers',
  approachSubtitle: 'Une méthodologie éprouvée pour des recrutements réussis',
  approach1Title: 'Analyse des Besoins',
  approach1Desc: 'Compréhension approfondie de vos besoins en compétences, niveau hiérarchique et contraintes spécifiques',
  approach2Title: 'Sélection Technique',
  approach2Desc: 'Sélection rigoureuse basée sur les compétences techniques et comportementales requises',
  approach3Title: 'Évaluation Réelle', 
  approach3Desc: 'Mise en situation réelle en environnement industriel pour valider les compétences pratiques',
  approach4Title: 'Accompagnement',
  approach4Desc: 'Intégration et suivi post-recrutement pour une pérennité optimale et une montée en compétences rapide',
  sectorsTitle: 'Secteurs d\'Intervention',
  sectorsSubtitle: 'Expertise sectorielle pour un recrutement ciblé et efficace',
  sector1: 'Textile & Habillement',
  sector2: 'Automobile',
  sector3: 'Agroalimentaire',
  sector4: 'Logistique', 
  sector5: 'Management Industriel',
  processTitle: 'Notre Processus de Recrutement',
  processSubtitle: 'Une démarche structurée pour des résultats garantis',
  process1Title: 'Analyse du Poste',
  process1Desc: 'Définition précise du profil recherché, des compétences requises et de la culture d\'entreprise',
  process2Title: 'Recherche & Présélection',
  process2Desc: 'Sourcing actif et présélection des candidats les plus pertinents selon vos critères',
  process3Title: 'Évaluation Technique',
  process3Desc: 'Tests techniques et mises en situation pour valider les compétences opérationnelles',
  process4Title: 'Évaluation Comportementale',
  process4Desc: 'Analyse des soft skills et adéquation avec la culture et les valeurs de l\'entreprise',
  process5Title: 'Présentation Shortlist',
  process5Desc: 'Sélection des meilleurs profils présentés avec une analyse détaillée de chaque candidat',
  process6Title: 'Intégration & Suivi',
  process6Desc: 'Accompagnement durant l\'intégration et suivi post-recrutement pour assurer la réussite',
  closingTitle: 'Focus sur la Performance Industrielle',
  closingText: 'Nos recrutements sont orientés vers l\'excellence opérationnelle et l\'amélioration continue, garantissant des collaborateurs performants et engagés.',
  stats: {
    talents: 'Talents Placés',
    successRate: 'Taux de Réussite',
    yearsExp: 'Années Exp.',
    sectors: 'Secteurs'
  },
  floatingBadge: {
    title: 'Experts RH',
    subtitle: 'Spécialistes industriels'
  },
  ctaButton: 'Recruter avec nous'
},
    // Dans votre fichier translations.js

    contact: {
      pageTitle: 'Contactez-Nous',
      pageSubtitle: 'Discutons de vos projets et de la manière dont nous pouvons vous accompagner',
      emailLabel: 'Email',
      addressLabel: 'Adresse',
      hoursLabel: 'Horaires',
      hoursValue1: 'Lundi - Vendredi',
      hoursValue2: '9h00 - 18h00',
      locationTitle: 'Notre Emplacement',
      locationDesc: 'ANGLE RUE AL ARAAR ET BD LALLA YACOUT IMM A APPT 8 CASABLANCA.',
      formTitle: 'Envoyez-nous un Message',
      formSubtitle: 'Remplissez le formulaire ci-dessous et nous vous contacterons via WhatsApp',
      nameLabel: 'Nom complet',
      namePlaceholder: 'Votre nom',
      emailPlaceholder: 'votre.email@exemple.com',
      phoneLabel: 'Téléphone',
      phonePlaceholder: '+212 XXX XXX XXX',
      companyLabel: 'Entreprise',
      companyPlaceholder: 'Nom de votre entreprise',
      messageLabel: 'Message',
      messagePlaceholder: 'Décrivez votre projet ou vos besoins...',
      submitButton: 'Envoyer via WhatsApp',
      formNote: 'En soumettant ce formulaire, vos informations seront envoyées directement à notre WhatsApp professionnel',
      ctaTitle: 'Prêt à Démarrer Votre Projet ?',
      ctaText: 'Contactez-nous dès aujourd\'hui pour discuter de vos besoins et découvrir comment nous pouvons vous aider à atteindre vos objectifs.',
      callButton: 'Appelez-nous',
      emailButton: 'Envoyez un email',
      mapDescription: "Notre bureau situé au cœur de Casablanca, facilement accessible"
    },
  about: {
  heroBadge: "À Propos de Nous",
  pageTitle: 'Texaconsult – Cabinet de Conseil en Industrie Manufacturière',
  pageSubtitle: 'Expert en excellence opérationnelle et accompagnement industriel',
  expertiseTitle: 'Notre Expertise Sectorielle',
  expertiseText1: 'Fondé par Elhoucine Laguetar, Texaconsult est un cabinet de conseil spécialisé dans l’excellence opérationnelle et l’accompagnement industriel.',
  expertiseText2: 'Nous intervenons auprès des entreprises manufacturières dans le secteur textile et habillement , l’automobile et l’agroalimentaire pour améliorer leurs performances, renforcer leurs compétences et optimiser leurs processus de production.',
  expertiseText3: 'Grâce à une approche terrain, pragmatique et humaine, Texaconsult aide ses partenaires à transformer leurs organisations, réduire les gaspillages et atteindre l’excellence industrielle durable.',
  valuesTitle: 'Notre Expertise Sectorielle',
  valuesSubtitle: 'Interventions spécialisées dans les secteurs clés de l\'industrie manufacturière',
  value1Title: '🧵 Industrie Textile et Habillement',
  value1Desc: 'Amélioration continue, lean manufacturing, équilibrage des lignes, formation technique et optimisation des processus de production textile.',
  value2Title: '🚗 Industrie Automobile',
  value2Desc: 'Optimisation des méthodes, qualité produit/process, maintenance industrielle et performance des ateliers de production automobile.',
  value3Title: '🧃 Industrie Agroalimentaire',
  value3Desc: 'Organisation industrielle, sécurité alimentaire, maîtrise des procédés et montée en compétences des équipes de production.',
  value4Title: '🏭 Excellence Opérationnelle',
  value4Desc: 'Transformation des organisations, réduction des gaspillages et mise en place de systèmes de performance industrielle durable.',
  missionTitle: 'Notre Mission',
  missionText1: 'Accompagner les entreprises manufacturières dans leur transformation vers l\'excellence opérationnelle grâce à des solutions concrètes et adaptées.',
  missionText2: 'Notre approche combine expertise sectorielle, méthodologies éprouvées et accompagnement terrain pour garantir des résultats mesurables et durables.',
  stat1: 'Années d\'Expérience',
  stat2: 'Projets Réussis',
  stat3: 'Secteurs d\'Intervention',
  stat4: 'Clients Satisfaits',
  ctaTitle: 'Prêt à Transformer Votre Performance Industrielle ?',
  ctaText: 'Découvrez comment Texaconsult peut vous accompagner dans l\'optimisation de vos processus et l\'amélioration de votre performance manufacturière.',
  ctaButton: 'Contactez-nous',
  clientsTitle: "Ils Nous Font Confiance",
  clientsSubtitle: "Découvrez les entreprises manufacturières qui nous ont choisi pour leur excellence opérationnelle",
  skill1: "Amélioration Continue",
  skill2: "Lean Manufacturing",
  skill3: "Optimisation des Processus", 
  skill4: "Formation Technique",
  expertTitle: "Expert Industriel",
  foundedBy: "Fondé par Elhoucine Laguetar",
    sectorsTitle: "Nos Secteurs d'Expertise",
    sectorsSubtitle: "Découvrez les domaines dans lesquels nous excellons",
    sectorAutomotive: "Secteur Automobile", 
    sectorAgrofood: "Secteur Agroalimentaire",
    sectorTextil: "Secteur Textile"

},
    whatsapp: {
      greeting: 'Bonjour! 👋',
      message: 'Comment pouvons-nous vous aider aujourd\'hui?',
      startButton: 'Démarrer la conversation',
      note: 'Cliquez pour ouvrir WhatsApp et nous contacter directement',
      online: 'En ligne',
      defaultMessage: 'Bonjour Texaconsult, je souhaite obtenir plus d\'informations sur vos services.'
    },
    footer: {
      description: 'Bureau de Consulting - Solutions sur-mesure pour votre performance industrielle.',
      quickLinks: 'Liens Rapides',
      contactTitle: 'Contact',
      copyright: 'Tous droits réservés.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      conseil: 'Consulting',
      accompagnement: 'Support',
      aiSolutions: 'AI Solutions',
      partnerships: 'Partnerships',
      training: 'Training',
      recruitment: 'Recruitment',
      about: 'About',
      contact: 'Contact'
    },
    home: {
      newsText: "🚀 Innovation • Excellence • Digital Transformation • AI & Advanced Solutions • Personalized Support • Certified Expertise",
      heroTitle: 'Excellence in',
      heroBadge: "Innovation & Excellence",
      statsTitle: "Our Key Figures",
      heroTitleHighlight: 'Industrial Performance',
      heroSubtitle: 'Tailored solutions to transform your business',
      stat1: 'Completed Projects',
      stat2: 'Satisfied Clients',
      stat3: 'Years of Experience',
      stat4: 'Satisfaction Rate',
      expertiseTitle: 'Our Areas of Expertise',
      expertiseSubtitle: 'Comprehensive and flexible solutions tailored to your specific needs',
      service1Title: 'Strategic Consulting',
      service1Desc: 'In-depth analysis and recommendations to optimize your industrial performance',
      service2Title: 'Operational Support',
      service2Desc: 'Integration into your teams to successfully carry out your transformation projects',
      service3Title: 'AI Solutions',
      service3Desc: 'Integration of artificial intelligence into your production processes',
      service4Title: 'International Partnerships',
      service4Desc: 'Development of Morocco-International industrial partnerships',
      ctaTitle: 'Ready to Transform Your Performance?',
      ctaDescription: 'Our experts are available to analyze your needs and offer you tailored solutions adapted to your industrial challenges.',
      ctaFeature1: 'Free diagnosis of your situation',
      ctaFeature2: 'Personalized and innovative solutions',
      ctaFeature3: 'End-to-end support from our experts',
      ctaButton: 'Start your project',
      supportLabel: 'Customer Support'
    },
     services: {
      pageTitle: 'Our Services',
      pageSubtitle: 'A comprehensive and flexible offering tailored to your specific needs',
      learnMore: 'Learn more',
      conseil: {
        description: 'Our consulting missions include in-depth analysis of your processes, identification of performance levers, and strategic recommendations to optimize your production.',
        feature1: 'Simplification of complex situations',
        feature2: 'Strategic recommendations and proposals',
        feature3: 'In-depth studies and project design',
        feature4: 'Identification of performance levers',
        feature5: 'Analysis of competitive practices'
      },
      accompagnement: {
        description: 'Our consultants integrate into your teams to support you in implementing your industrial projects, from benchmarking to operations supervision.',
        feature1: 'Complete integration into your teams',
        feature2: 'Supervision and mission execution',
        feature3: 'Application of proven methodologies',
        feature4: 'Creation and improvement of standards',
        feature5: 'Transition from project phase to series phase'
      },
      ai: {
        description: 'Collaboration with technology start-ups to integrate artificial intelligence into your industrial methods and optimize your production processes.',
        feature1: 'AI-assisted methods agents',
        feature2: 'Advanced management tools',
        feature3: 'Custom innovative projects',
        feature4: 'Improvement of operational efficiency',
        feature5: 'Real-time decision optimization'
      },
      partnerships: {
        description: 'Support in international prospecting and facilitation of partnerships between foreign clients and Moroccan industrialists, with a focus on manufacturing performance.',
        feature1: 'Targeted international prospecting',
        feature2: 'Facilitation of Morocco-International partnerships',
        feature3: 'Focus on manufacturing performance',
        feature4: 'Connection with qualified industrialists',
        feature5: 'Support in development'
      },
      training: {
  description: 'Customized training programs to develop your teams skills and optimize your industrial performance.',
  feature1: 'Methods, Process & Industrialization',
  feature2: 'Production – Workshop Management',
  feature3: 'Quality & Continuous Improvement',
  feature4: 'Lean Manufacturing',
  feature5: 'Management & Organization',
  feature6: 'Leadership & Management',
  feature7: 'Industrial Maintenance & Equipment Reliability',
  feature8: 'Technical Skills & Digitalization',
  feature9: 'Soft Skills'
},
recruitment: {
  description: 'Complete talent acquisition solution for industrial sectors with a 4-pillar approach.',
  feature1: 'Understanding client needs (skills, level, constraints)',
  feature2: 'Selection based on technical and behavioral competencies',
  feature3: 'Real evaluation in industrial environment',
  feature4: 'Integration and post-recruitment support',
  feature5: 'Position analysis & required profile',
  feature6: 'Research & pre-selection'
},

    },
    conseil: {
      pageTitle: 'Strategic Consulting',
      pageSubtitle: 'Expertise and recommendations to optimize your industrial performance',
      missionsTitle: 'Our Consulting Missions',
      missionsSubtitle: 'Personalized support to improve your quality, productivity, and manufacturing lead times',
      mission1: 'Simplify a complex situation',
      mission2: 'Make recommendations or proposals',
      mission3: 'Conduct an in-depth study and design a detailed project',
      mission4: 'Identify performance levers and corrective actions',
      mission5: 'Conduct a field mission at the client\'s site, followed by analysis and reporting phase',
      mission6: 'Perform an in-depth analysis',
      mission7: 'Study competitors\' practices',
      approachTitle: 'Our Approach',
      approachSubtitle: 'A structured methodology for measurable results',
      step1Title: 'Diagnosis',
      step1Desc: 'Complete analysis of your current situation and identification of improvement opportunities',
      step2Title: 'Recommendations',
      step2Desc: 'Strategic proposals based on best practices and adapted to your context',
      step3Title: 'Action Plan',
      step3Desc: 'Detailed roadmap with priorities, resources, and performance indicators',
      step4Title: 'Support',
      step4Desc: 'Follow-up and support in implementing recommendations to ensure results',
      closingTitle: 'For a Successful Transformation',
      closingText: 'We offer comprehensive support including strategic consulting, employee training, and operational support in project implementation.',
      cta: 'Contact us'
    },
    accompagnement: {
      pageTitle: 'Operational Support',
      pageSubtitle: 'Integration into your teams to successfully carry out your transformation projects',
      specialtiesTitle: 'Our 3 Complementary Specialties',
      specialtiesSubtitle: 'A comprehensive approach to support your industrial transformation',
      specialty1Title: 'Consulting',
      specialty1Desc: 'Strategic analysis and recommendations for your industrial projects',
      specialty2Title: 'Training',
      specialty2Desc: 'Skills development for your teams on best practices',
      specialty3Title: 'Operational Support',
      specialty3Desc: 'On-site presence for project implementation and monitoring',
      missionsTitle: 'Our Support Missions',
      missionsSubtitle: 'Texaconsult consultants are integrated into your teams and work with you',
      mission1: 'Support the client in implementing an industrial project',
      mission2: 'Intervene full-time at the client\'s site to supervise or carry out a mission',
      mission3: 'Address a lack of resources and/or skills',
      mission4: 'Apply, improve, or create production standards',
      mission5: 'Supervise operations and ensure quality',
      mission6: 'Implement proven methodologies',
      mission7: 'Propose adapted innovative approaches',
      phasesTitle: 'From Project to Series',
      phasesSubtitle: 'Support in all phases of your industrial development',
      phase1Title: 'Project Phase',
      phase1Desc: 'Support in the design and development phase of your industrial projects',
      phase2Title: 'Series Phase',
      phase2Desc: 'Support in the transition to series production and continuous optimization',
      closingTitle: 'Proven Methodologies and Innovative Approaches',
      closingText: 'From benchmarking to operations supervision, we apply proven methodologies while also offering innovative approaches tailored to your needs.',
      teamIntegration: "Team Integration"
    },
    aiSolutions: {
      pageTitle: 'AI Solutions',
      pageSubtitle: 'Integration of artificial intelligence into your industrial methods',
      collaborationTitle: 'Collaboration with Technology Start-ups',
      collaborationSubtitle: 'We collaborate with innovative start-ups to integrate the latest AI technologies into your production processes',
      solution1Title: 'AI-Assisted Methods Agents',
      solution1Desc: 'Implementation of intelligent agents to optimize your production processes and improve decision-making',
      solution2Title: 'Advanced Management Tools',
      solution2Desc: 'Development of real-time monitoring and management tools for better operational visibility',
      solution3Title: 'Custom Innovative Projects',
      solution3Desc: 'Creation of personalized AI solutions adapted to your specific industrial challenges',
      benefitsTitle: 'Benefits of Industrial AI',
      benefitsSubtitle: 'Improvement of efficiency, accuracy, and speed of operational decisions',
      benefit1Title: 'Increased Efficiency',
      benefit1Desc: 'Automation of repetitive tasks and process optimization to increase productivity',
      benefit2Title: 'Improved Accuracy',
      benefit2Desc: 'Error reduction and quality improvement through predictive analysis',
      benefit3Title: 'Fast Decisions',
      benefit3Desc: 'Accelerated decision-making through real-time data analysis',
      optimizationTitle: 'Optimization at Every Process Stage',
      optimizationText: 'Our AI solutions are designed to improve efficiency, accuracy, and speed of operational decisions at every stage of your industrial process, from design to production.',
      approachTitle: 'A Collaborative Approach',
      approachText: 'In partnership with cutting-edge technology start-ups, we bring the most innovative AI solutions tailored to your specific needs. Our collaborative approach ensures smooth integration and measurable results.',
      industrialAI: "Industrial AI"
    },
    partnerships: {
      pageTitle: 'International Partnerships',
      pageSubtitle: 'Development of Morocco - International industrial partnerships',
      servicesTitle: 'Our Partnership Services',
      servicesSubtitle: 'Support in international prospecting and facilitation of strategic partnerships',
      service1Title: 'International Prospecting',
      service1Desc: 'Identification and approach of potential international partners to develop your network',
      service2Title: 'Partnership Facilitation',
      service2Desc: 'Connecting foreign clients with qualified Moroccan industrialists',
      service3Title: 'Manufacturing Performance',
      service3Desc: 'Focus on operational excellence and continuous process improvement',
      advantagesTitle: 'Our Advantages',
      advantagesSubtitle: 'Why choose Texaconsult for your international partnerships',
      advantage1Title: 'Sector Expertise',
      advantage1Desc: 'In-depth knowledge of industrial sectors and international markets',
      advantage2Title: 'Extensive Network',
      advantage2Desc: 'Access to a large network of Moroccan industrialists and international clients',
      advantage3Title: 'Comprehensive Support',
      advantage3Desc: 'Support at all stages of partnership development',
      processTitle: 'Our Process',
      processSubtitle: 'A structured approach for successful partnerships',
      process1Title: 'Needs Analysis',
      process1Desc: 'In-depth understanding of your partnership objectives and criteria',
      process2Title: 'Identification',
      process2Desc: 'Research and selection of potential partners matching your needs',
      process3Title: 'Connection',
      process3Desc: 'Organization of meetings and facilitation of exchanges between parties',
      process4Title: 'Support',
      process4Desc: 'Continuous support in partnership development and sustainability',
      closingTitle: 'Focus on Manufacturing Performance',
      closingText: 'Our partnerships are focused on operational excellence and continuous improvement of manufacturing processes, ensuring lasting and mutually beneficial relationships.',
      location: "Morocco - International"
    },
    training: {
  pageTitle: 'Industrial Training',
  pageSubtitle: 'Skills development to optimize your industrial performance',
  domainsTitle: 'Our Training Areas',
  domainsSubtitle: 'Customized programs adapted to your specific needs',
  domain1Title: 'Methods, Process & Industrialization',
  domain1Desc: 'Optimization of industrial production processes and methods to improve efficiency and productivity',
  domain2Title: 'Production – Workshop Management',
  domain2Desc: 'Management and optimization of production workshops with focus on operational management',
  domain3Title: 'Quality & Continuous Improvement', 
  domain3Desc: 'Implementation of quality systems and continuous improvement approaches for sustainable excellence',
  domain4Title: 'Lean Manufacturing',
  domain4Desc: 'Waste reduction and flow optimization for more efficient production',
  domain5Title: 'Management & Organization',
  domain5Desc: 'Structuring and management of industrial organizations for increased performance',
  domain6Title: 'Leadership & Management',
  domain6Desc: 'Development of managerial skills and leadership to lead teams effectively',
  domain7Title: 'Industrial Maintenance & Reliability',
  domain7Desc: 'Maintenance optimization and equipment reliability to reduce downtime',
  domain8Title: 'Technical Skills & Digitalization', 
  domain8Desc: 'Training in new technologies and industrial digitalization to remain competitive',
  domain9Title: 'Soft Skills',
  domain9Desc: 'Development of behavioral and relational skills for effective collaboration',
  approachTitle: 'Our Pedagogical Approach',
  approachSubtitle: 'A methodology adapted to industrial challenges',
  step1Title: 'Needs Analysis',
  step1Desc: 'In-depth assessment of your skills needs and definition of training objectives',
  step2Title: 'Custom Design',
  step2Desc: 'Development of programs adapted to your specific industrial context',
  step3Title: 'Practical Animation',
  step3Desc: 'Training delivered by field experts with real-life simulations',
  step4Title: 'Evaluation & Follow-up',
  step4Desc: 'Measurement of learning outcomes and support in implementing new skills',
  closingTitle: 'For Sustainable Skills Development',
  closingText: 'We offer training that combines theory and practice, ensuring effective and measurable skills transfer in your industrial environment.',
   stats: {
    domains: "Domains",
    trained: "Trained",
    satisfaction: "Satisfaction",
    yearsExp: "Years Exp."
  },
  features: {
    processOptimization: "Process optimization",
    productionMethods: "Production methods",
    industrialization: "Industrialization",
    workshopManagement: "Workshop management",
    teamSupervision: "Team supervision",
    operationalPerformance: "Operational performance",
    qualitySystems: "Quality systems",
    continuousImprovement: "Continuous improvement",
    performanceIndicators: "Performance indicators",
    wasteReduction: "Waste reduction",
    flowOptimization: "Flow optimization",
    organizationStructure: "Organization structure",
    industrialManagement: "Industrial management",
    performanceSteering: "Performance steering",
    leadership: "Leadership",
    management: "Management",
    skillsDevelopment: "Skills development"
  },
  floatingBadge: {
    title: "Certified Experts",
    subtitle: "Industrial Trainers"
  },
  ctaButton: "Request a quote"
},
recruitment: {
  pageTitle: 'Industrial Recruitment',
  pageSubtitle: 'Complete talent acquisition solution for industry',
  approachTitle: 'Our Approach – 4 Pillars',
  approachSubtitle: 'A proven methodology for successful recruitment',
  approach1Title: 'Needs Analysis',
  approach1Desc: 'In-depth understanding of your skills needs, hierarchical level and specific constraints',
  approach2Title: 'Technical Selection',
  approach2Desc: 'Rigorous selection based on required technical and behavioral competencies',
  approach3Title: 'Real Evaluation', 
  approach3Desc: 'Real situation testing in industrial environment to validate practical skills',
  approach4Title: 'Support',
  approach4Desc: 'Integration and post-recruitment follow-up for optimal sustainability and rapid skills development',
  sectorsTitle: 'Intervention Sectors',
  sectorsSubtitle: 'Sector expertise for targeted and effective recruitment',
  sector1: 'Textile & Apparel',
  sector2: 'Automotive',
  sector3: 'Food Industry',
  sector4: 'Logistics', 
  sector5: 'Industrial Management',
  processTitle: 'Our Recruitment Process',
  processSubtitle: 'A structured approach for guaranteed results',
  process1Title: 'Position Analysis',
  process1Desc: 'Precise definition of required profile, needed skills and company culture',
  process2Title: 'Research & Pre-selection',
  process2Desc: 'Active sourcing and pre-selection of most relevant candidates according to your criteria',
  process3Title: 'Technical Evaluation',
  process3Desc: 'Technical tests and real situations to validate operational skills',
  process4Title: 'Behavioral Assessment',
  process4Desc: 'Analysis of soft skills and fit with company culture and values',
  process5Title: 'Shortlist Presentation',
  process5Desc: 'Selection of best profiles presented with detailed analysis of each candidate',
  process6Title: 'Integration & Follow-up',
  process6Desc: 'Support during integration and post-recruitment follow-up to ensure success',
  closingTitle: 'Focus on Industrial Performance',
  closingText: 'Our recruitment is oriented towards operational excellence and continuous improvement, guaranteeing performing and committed collaborators.',
  stats: {
    talents: 'Talents Placed',
    successRate: 'Success Rate',
    yearsExp: 'Years Exp.',
    sectors: 'Sectors'
  },
  floatingBadge: {
    title: 'HR Experts',
    subtitle: 'Industrial Specialists'
  },
  ctaButton: 'Recruit with us'
},
    contact: {
      pageTitle: 'Contact Us',
      pageSubtitle: 'Let\'s discuss your projects and how we can support you',
      emailLabel: 'Email',
      addressLabel: 'Address',
      hoursLabel: 'Hours',
      hoursValue1: 'Monday - Friday',
      hoursValue2: '9:00 AM - 6:00 PM',
      locationTitle: 'Our Location',
      locationDesc: 'CORNER OF AL ARAAR STREET AND LALLA YACOUT BOULEVARD, BUILDING A, APARTMENT 8, CASABLANCA.',
      formTitle: 'Send Us a Message',
      formSubtitle: 'Fill out the form below and we will contact you via WhatsApp',
      nameLabel: 'Full name',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'your.email@example.com',
      phoneLabel: 'Phone',
      phonePlaceholder: '+212 XXX XXX XXX',
      companyLabel: 'Company',
      companyPlaceholder: 'Your company name',
      messageLabel: 'Message',
      messagePlaceholder: 'Describe your project or needs...',
      submitButton: 'Send via WhatsApp',
      formNote: 'By submitting this form, your information will be sent directly to our professional WhatsApp',
      ctaTitle: 'Ready to Start Your Project?',
      ctaText: 'Contact us today to discuss your needs and discover how we can help you achieve your goals.',
      callButton: 'Call us',
      emailButton: 'Send an email',
      mapDescription: "Our office located in the heart of Casablanca, easily accessible"

    },
   about: {
  heroBadge: "About Us",
  pageTitle: 'Texaconsult – Manufacturing Industry Consulting Firm',
  pageSubtitle: 'Expert in operational excellence and industrial support',
  expertiseTitle: 'Our Sector Expertise',
  expertiseText1: 'Founded by Elhoucine Laguetar, Texaconsult is a consulting firm specialized in operational excellence and industrial support.',
  expertiseText2: 'We work with manufacturing companies in the textile and clothing sector, the automotive industry, and the agri-food sector to improve their performance, strengthen their skills, and optimize their production processes.',
  expertiseText3: 'Through a field-based, pragmatic, and human approach, Texaconsult helps its partners transform their organizations, reduce waste, and achieve sustainable industrial excellence.',
  valuesTitle: 'Our Sector Expertise',
  valuesSubtitle: 'Specialized interventions in key manufacturing industry sectors',
  value1Title: '🧵 Textile and Apparel Industry',
  value1Desc: 'Continuous improvement, lean manufacturing, line balancing, technical training, and optimization of textile production processes.',
  value2Title: '🚗 Automotive Industry',
  value2Desc: 'Methods optimization, product/process quality, industrial maintenance, and performance of automotive production workshops.',
  value3Title: '🧃 Food Industry',
  value3Desc: 'Industrial organization, food safety, process control, and skills development for production teams.',
  value4Title: '🏭 Operational Excellence',
  value4Desc: 'Organizational transformation, waste reduction, and implementation of sustainable industrial performance systems.',
  missionTitle: 'Our Mission',
  missionText1: 'Support manufacturing companies in their transformation towards operational excellence through concrete and adapted solutions.',
  missionText2: 'Our approach combines sector expertise, proven methodologies, and field support to guarantee measurable and sustainable results.',
  stat1: 'Years of Experience',
  stat2: 'Successful Projects',
  stat3: 'Sectors of Intervention',
  stat4: 'Satisfied Clients',
  ctaTitle: 'Ready to Transform Your Industrial Performance?',
  ctaText: 'Discover how Texaconsult can support you in optimizing your processes and improving your manufacturing performance.',
  ctaButton: 'Contact us',
  clientsTitle: "They Trust Us",
  clientsSubtitle: "Discover the manufacturing companies that have chosen us for their operational excellence",
  skill1: "Continuous Improvement",
  skill2: "Lean Manufacturing",
  skill3: "Process Optimization",
  skill4: "Technical Training",
  expertTitle: "Industrial Expert", 
  foundedBy: "Founded by Elhoucine Laguetar",
   sectorsTitle: "Our Expertise Sectors",
    sectorsSubtitle: "Discover the domains in which we excel",
    sectorAutomotive: "Automotive Sector",
    sectorAgrofood: "Agrofood Sector",
    sectorTextil: "Textile Sector"
},
    whatsapp: {
      greeting: 'Hello! 👋',
      message: 'How can we help you today?',
      startButton: 'Start conversation',
      note: 'Click to open WhatsApp and contact us directly',
      online: 'Online',
      defaultMessage: 'Hello Texaconsult, I would like more information about your services.'
    },
    footer: {
      description: 'Consulting Firm - Tailored solutions for your industrial performance.',
      quickLinks: 'Quick Links',
      contactTitle: 'Contact',
      copyright: 'All rights reserved.'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      conseil: 'Consultoría',
      accompagnement: 'Acompañamiento',
      aiSolutions: 'Soluciones IA',
      partnerships: 'Asociaciones',
      training: 'Formación',
      recruitment: 'Reclutamiento',
      about: 'Sobre Nosotros',
      contact: 'Contacto'
    },
    home: {
      newsText: "🚀 Innovación • Excelencia • Transformación Digital • IA & Soluciones Avanzadas • Acompañamiento Personalizado • Experiencia Certificada",
      heroTitle: 'Excelencia en',
      heroBadge: "Innovación & Excelencia",
      statsTitle: "Nuestras Cifras Clave",
      heroTitleHighlight: 'Rendimiento Industrial',
      heroSubtitle: 'Soluciones a medida para transformar su empresa',
      stat1: 'Proyectos Realizados',
      stat2: 'Clientes Satisfechos',
      stat3: 'Años de Experiencia',
      stat4: 'Tasa de Satisfacción',
      expertiseTitle: 'Nuestras Áreas de Experiencia',
      expertiseSubtitle: 'Soluciones completas y flexibles adaptadas a sus necesidades específicas',
      service1Title: 'Consultoría Estratégica',
      service1Desc: 'Análisis en profundidad y recomendaciones para optimizar su rendimiento industrial',
      service2Title: 'Acompañamiento Operacional',
      service2Desc: 'Integración en sus equipos para llevar a cabo sus proyectos de transformación',
      service3Title: 'Soluciones IA',
      service3Desc: 'Integración de inteligencia artificial en sus procesos de producción',
      service4Title: 'Asociaciones Internacionales',
      service4Desc: 'Desarrollo de asociaciones industriales Marruecos-Internacional',
      ctaTitle: '¿Listo para Transformar su Rendimiento?',
      ctaDescription: 'Nuestros expertos están disponibles para analizar sus necesidades y ofrecerle soluciones a medida adaptadas a sus desafíos industriales.',
      ctaFeature1: 'Diagnóstico gratuito de su situación',
      ctaFeature2: 'Soluciones personalizadas e innovadoras',
      ctaFeature3: 'Acompañamiento de principio a fin por nuestros expertos',
      ctaButton: 'Iniciar su proyecto',
      supportLabel: 'Soporte al Cliente'
    },
    services: {
      pageTitle: 'Nuestros Servicios',
      pageSubtitle: 'Una oferta completa y flexible adaptada a sus necesidades específicas',
      learnMore: 'Saber más',
      conseil: {
        description: 'Nuestras misiones de consultoría incluyen el análisis en profundidad de sus procesos, la identificación de palancas de rendimiento y recomendaciones estratégicas para optimizar su producción.',
        feature1: 'Simplificación de situaciones complejas',
        feature2: 'Recomendaciones y propuestas estratégicas',
        feature3: 'Estudios en profundidad y diseño de proyectos',
        feature4: 'Identificación de palancas de rendimiento',
        feature5: 'Análisis de prácticas competitivas'
      },
      accompagnement: {
        description: 'Nuestros consultores se integran en sus equipos para apoyarle en la implementación de sus proyectos industriales, desde el benchmarking hasta la supervisión de operaciones.',
        feature1: 'Integración completa en sus equipos',
        feature2: 'Supervisión y ejecución de misiones',
        feature3: 'Aplicación de metodologías probadas',
        feature4: 'Creación y mejora de estándares',
        feature5: 'Transición de la fase proyecto a la fase serie'
      },
      ai: {
        description: 'Colaboración con startups tecnológicas para integrar inteligencia artificial en sus métodos industriales y optimizar sus procesos de producción.',
        feature1: 'Agentes de métodos asistidos por IA',
        feature2: 'Herramientas de gestión avanzadas',
        feature3: 'Proyectos innovadores a medida',
        feature4: 'Mejora de la eficiencia operacional',
        feature5: 'Optimización de decisiones en tiempo real'
      },
      partnerships: {
        description: 'Apoyo en prospección internacional y facilitación de asociaciones entre clientes extranjeros e industriales marroquíes, con enfoque en el rendimiento manufacturero.',
        feature1: 'Prospección internacional dirigida',
        feature2: 'Facilitación de asociaciones Marruecos-Internacional',
        feature3: 'Enfoque en el rendimiento manufacturero',
        feature4: 'Conexión con industriales calificados',
        feature5: 'Apoyo en el desarrollo'
      },
      training: {
  description: 'Programas de formación a medida para desarrollar las competencias de sus equipos y optimizar su rendimiento industrial.',
  feature1: 'Métodos, Proceso & Industrialización',
  feature2: 'Producción – Gestión de Taller',
  feature3: 'Calidad & Mejora Continua',
  feature4: 'Lean Manufacturing',
  feature5: 'Gestión & Organización',
  feature6: 'Liderazgo & Gestión',
  feature7: 'Mantenimiento Industrial & Fiabilidad de Equipos',
  feature8: 'Competencias Técnicas & Digitalización',
  feature9: 'Soft Skills'
},
recruitment: {
  description: 'Solución integral de adquisición de talentos para sectores industriales con un enfoque basado en 4 pilares.',
  feature1: 'Comprensión de la necesidad del cliente (competencias, nivel, restricciones)',
  feature2: 'Selección por competencias técnicas y comportamentales',
  feature3: 'Evaluación real en entorno industrial',
  feature4: 'Integración y acompañamiento post-reclutamiento',
  feature5: 'Análisis del puesto & perfil buscado',
  feature6: 'Búsqueda & preselección'
},

    },
    conseil: {
      pageTitle: 'Consultoría Estratégica',
      pageSubtitle: 'Experiencia y recomendaciones para optimizar su rendimiento industrial',
      missionsTitle: 'Nuestras Misiones de Consultoría',
      missionsSubtitle: 'Un acompañamiento personalizado para mejorar su calidad, productividad y plazos de fabricación',
      mission1: 'Simplificar una situación complicada',
      mission2: 'Hacer recomendaciones o propuestas',
      mission3: 'Conducir un estudio en profundidad y diseñar un proyecto detallado',
      mission4: 'Identificar palancas de rendimiento y acciones correctivas',
      mission5: 'Realizar una misión de campo en el cliente, seguida de una fase de análisis y redacción',
      mission6: 'Realizar un análisis en profundidad',
      mission7: 'Estudiar las prácticas de los competidores',
      approachTitle: 'Nuestro Enfoque',
      approachSubtitle: 'Una metodología estructurada para resultados medibles',
      step1Title: 'Diagnóstico',
      step1Desc: 'Análisis completo de su situación actual e identificación de oportunidades de mejora',
      step2Title: 'Recomendaciones',
      step2Desc: 'Propuestas estratégicas basadas en mejores prácticas y adaptadas a su contexto',
      step3Title: 'Plan de Acción',
      step3Desc: 'Hoja de ruta detallada con prioridades, recursos e indicadores de rendimiento',
      step4Title: 'Acompañamiento',
      step4Desc: 'Seguimiento y apoyo en la implementación de recomendaciones para garantizar resultados',
      closingTitle: 'Para una Transformación Exitosa',
      closingText: 'Ofrecemos un acompañamiento completo incluyendo consultoría estratégica, formación de sus colaboradores y apoyo operacional en la implementación de proyectos.',
      cta: 'Contáctenos'
    },
    accompagnement: {
      pageTitle: 'Acompañamiento Operacional',
      pageSubtitle: 'Integración en sus equipos para llevar a cabo sus proyectos de transformación',
      specialtiesTitle: 'Nuestras 3 Especialidades Complementarias',
      specialtiesSubtitle: 'Un enfoque completo para acompañar su transformación industrial',
      specialty1Title: 'Consultoría',
      specialty1Desc: 'Análisis y recomendaciones estratégicas para sus proyectos industriales',
      specialty2Title: 'Formación',
      specialty2Desc: 'Desarrollo de competencias de sus equipos en mejores prácticas',
      specialty3Title: 'Acompañamiento Operacional',
      specialty3Desc: 'Presencia en terreno para la implementación y seguimiento de proyectos',
      missionsTitle: 'Nuestras Misiones de Acompañamiento',
      missionsSubtitle: 'Los consultores de Texaconsult se integran en sus equipos y trabajan con usted',
      mission1: 'Acompañar al cliente en la implementación de un proyecto industrial',
      mission2: 'Intervenir a tiempo completo en el cliente para supervisar o realizar una misión',
      mission3: 'Suplir una falta de recursos y/o competencias',
      mission4: 'Aplicar, mejorar o crear estándares de producción',
      mission5: 'Supervisar operaciones y garantizar calidad',
      mission6: 'Implementar metodologías probadas',
      mission7: 'Proponer enfoques innovadores adaptados',
      phasesTitle: 'Del Proyecto a la Serie',
      phasesSubtitle: 'Acompañamiento en todas las fases de su desarrollo industrial',
      phase1Title: 'Fase Proyecto',
      phase1Desc: 'Acompañamiento en la fase de diseño y desarrollo de sus proyectos industriales',
      phase2Title: 'Fase Serie',
      phase2Desc: 'Apoyo en la transición hacia producción en serie y optimización continua',
      closingTitle: 'Metodologías Probadas y Enfoques Innovadores',
      closingText: 'Desde el benchmarking hasta la supervisión de operaciones, aplicamos metodologías que han demostrado su eficacia mientras proponemos enfoques innovadores adaptados a sus necesidades.',
      teamIntegration: "Integración de Equipo"
    },
    aiSolutions: {
      pageTitle: 'Soluciones IA',
      pageSubtitle: 'Integración de inteligencia artificial en sus métodos industriales',
      collaborationTitle: 'Colaboración con Startups Tecnológicas',
      collaborationSubtitle: 'Colaboramos con startups innovadoras para integrar las últimas tecnologías de IA en sus procesos de producción',
      solution1Title: 'Agentes de Métodos Asistidos por IA',
      solution1Desc: 'Implementación de agentes inteligentes para optimizar sus procesos de producción y mejorar la toma de decisiones',
      solution2Title: 'Herramientas de Gestión Avanzadas',
      solution2Desc: 'Desarrollo de herramientas de monitoreo y gestión en tiempo real para una mejor visibilidad operacional',
      solution3Title: 'Proyectos Innovadores a Medida',
      solution3Desc: 'Creación de soluciones IA personalizadas adaptadas a sus desafíos industriales específicos',
      benefitsTitle: 'Beneficios de la IA Industrial',
      benefitsSubtitle: 'Mejora de la eficiencia, precisión y rapidez de las decisiones operacionales',
      benefit1Title: 'Eficiencia Aumentada',
      benefit1Desc: 'Automatización de tareas repetitivas y optimización de procesos para ganar en productividad',
      benefit2Title: 'Precisión Mejorada',
      benefit2Desc: 'Reducción de errores y mejora de calidad mediante análisis predictivo',
      benefit3Title: 'Decisiones Rápidas',
      benefit3Desc: 'Aceleración de la toma de decisiones gracias al análisis de datos en tiempo real',
      optimizationTitle: 'Optimización en Cada Etapa del Proceso',
      optimizationText: 'Nuestras soluciones de IA están diseñadas para mejorar la eficiencia, precisión y rapidez de las decisiones operacionales en cada etapa de su proceso industrial, desde el diseño hasta la producción.',
      approachTitle: 'Un Enfoque Colaborativo',
      approachText: 'En asociación con startups tecnológicas de vanguardia, aportamos las soluciones de IA más innovadoras y adaptadas a sus necesidades específicas. Nuestro enfoque colaborativo garantiza una integración fluida y resultados medibles.',
      industrialAI: "IA Industrial"
    },
    partnerships: {
      pageTitle: 'Asociaciones Internacionales',
      pageSubtitle: 'Desarrollo de asociaciones industriales Marruecos - Internacional',
      servicesTitle: 'Nuestros Servicios de Asociación',
      servicesSubtitle: 'Apoyo en prospección internacional y facilitación de asociaciones estratégicas',
      service1Title: 'Prospección Internacional',
      service1Desc: 'Identificación y acercamiento a socios potenciales internacionales para desarrollar su red',
      service2Title: 'Facilitación de Asociaciones',
      service2Desc: 'Conexión entre clientes extranjeros e industriales marroquíes calificados',
      service3Title: 'Rendimiento Manufacturero',
      service3Desc: 'Enfoque en la excelencia operacional y mejora continua de procesos',
      advantagesTitle: 'Nuestras Ventajas',
      advantagesSubtitle: 'Por qué elegir Texaconsult para sus asociaciones internacionales',
      advantage1Title: 'Experiencia Sectorial',
      advantage1Desc: 'Conocimiento profundo de sectores industriales y mercados internacionales',
      advantage2Title: 'Red Extendida',
      advantage2Desc: 'Acceso a una amplia red de industriales marroquíes y clientes internacionales',
      advantage3Title: 'Acompañamiento Completo',
      advantage3Desc: 'Apoyo en todas las etapas del desarrollo de asociación',
      processTitle: 'Nuestro Proceso',
      processSubtitle: 'Un enfoque estructurado para asociaciones exitosas',
      process1Title: 'Análisis de Necesidades',
      process1Desc: 'Comprensión profunda de sus objetivos y criterios de asociación',
      process2Title: 'Identificación',
      process2Desc: 'Investigación y selección de socios potenciales que coincidan con sus necesidades',
      process3Title: 'Conexión',
      process3Desc: 'Organización de reuniones y facilitación de intercambios entre partes',
      process4Title: 'Acompañamiento',
      process4Desc: 'Apoyo continuo en el desarrollo y sostenibilidad de la asociación',
      closingTitle: 'Enfoque en el Rendimiento Manufacturero',
      closingText: 'Nuestras asociaciones se centran en la excelencia operacional y la mejora continua de los procesos de fabricación, garantizando relaciones duraderas y mutuamente beneficiosas.',
      location: "Marruecos - Internacional"
    },
    training: {
  pageTitle: 'Formación Industrial',
  pageSubtitle: 'Desarrollo de competencias para optimizar su rendimiento industrial',
  domainsTitle: 'Nuestras Áreas de Formación',
  domainsSubtitle: 'Programas a medida adaptados a sus necesidades específicas',
  domain1Title: 'Métodos, Proceso & Industrialización',
  domain1Desc: 'Optimización de procesos y métodos de producción industrial para mejorar la eficiencia y productividad',
  domain2Title: 'Producción – Gestión de Taller',
  domain2Desc: 'Gestión y optimización de talleres de producción con enfoque en la gestión operacional',
  domain3Title: 'Calidad & Mejora Continua', 
  domain3Desc: 'Implementación de sistemas de calidad y enfoques de mejora continua para una excelencia sostenible',
  domain4Title: 'Lean Manufacturing',
  domain4Desc: 'Reducción de desperdicios y optimización de flujos para una producción más eficiente',
  domain5Title: 'Gestión & Organización',
  domain5Desc: 'Estructuración y gestión de organizaciones industriales para un rendimiento aumentado',
  domain6Title: 'Liderazgo & Gestión',
  domain6Desc: 'Desarrollo de competencias directivas y liderazgo para dirigir equipos efectivamente',
  domain7Title: 'Mantenimiento Industrial & Fiabilidad',
  domain7Desc: 'Optimización del mantenimiento y fiabilidad de equipos para reducir tiempos de parada',
  domain8Title: 'Competencias Técnicas & Digitalización', 
  domain8Desc: 'Formación en nuevas tecnologías y digitalización industrial para mantenerse competitivo',
  domain9Title: 'Soft Skills',
  domain9Desc: 'Desarrollo de competencias comportamentales y relacionales para una colaboración efectiva',
  approachTitle: 'Nuestro Enfoque Pedagógico',
  approachSubtitle: 'Una metodología adaptada a los desafíos industriales',
  step1Title: 'Análisis de Necesidades',
  step1Desc: 'Evaluación profunda de sus necesidades en competencias y definición de objetivos de formación',
  step2Title: 'Diseño a Medida',
  step2Desc: 'Desarrollo de programas adaptados a su contexto industrial específico',
  step3Title: 'Animación Práctica',
  step3Desc: 'Formaciones animadas por expertos de terreno con puesta en situación real',
  step4Title: 'Evaluación & Seguimiento',
  step4Desc: 'Medición de aprendizajes y acompañamiento en la implementación de nuevas competencias',
  closingTitle: 'Para un Desarrollo de Competencias Sostenible',
  closingText: 'Ofrecemos formaciones que combinan teoría y práctica, asegurando una transferencia de competencias efectiva y medible en su entorno industrial.',
   "stats": {
    "domains": "Dominios",
    "trained": "Formados",
    "satisfaction": "Satisfacción",
    "yearsExp": "Años Exp."
  },
  "features": {
    "processOptimization": "Optimización procesos",
    "productionMethods": "Métodos producción",
    "industrialization": "Industrialización",
    "workshopManagement": "Gestión taller",
    "teamSupervision": "Supervisión equipo",
    "operationalPerformance": "Rendimiento operacional",
    "qualitySystems": "Sistemas calidad",
    "continuousImprovement": "Mejora continua",
    "performanceIndicators": "Indicadores rendimiento",
    "wasteReduction": "Redución desperdicios",
    "flowOptimization": "Optimización flujos",
    "organizationStructure": "Estructura organización",
    "industrialManagement": "Gestión industrial",
    "performanceSteering": "Dirección rendimiento",
    "leadership": "Liderazgo",
    "management": "Gestión",
    "skillsDevelopment": "Desarrollo competencias"
  },
  "floatingBadge": {
    "title": "Expertos Certificados",
    "subtitle": "Formadores industriales"
  },
  "ctaButton": "Solicitar presupuesto"
},
recruitment: {
  pageTitle: 'Reclutamiento Industrial',
  pageSubtitle: 'Solución integral de adquisición de talentos para la industria',
  approachTitle: 'Nuestro Enfoque – 4 Pilares',
  approachSubtitle: 'Una metodología probada para reclutamientos exitosos',
  approach1Title: 'Análisis de Necesidades',
  approach1Desc: 'Comprensión profunda de sus necesidades en competencias, nivel jerárquico y restricciones específicas',
  approach2Title: 'Selección Técnica',
  approach2Desc: 'Selección rigurosa basada en las competencias técnicas y comportamentales requeridas',
  approach3Title: 'Evaluación Real', 
  approach3Desc: 'Puesta en situación real en entorno industrial para validar las competencias prácticas',
  approach4Title: 'Acompañamiento',
  approach4Desc: 'Integración y seguimiento post-reclutamiento para una perdurabilidad óptima y desarrollo rápido de competencias',
  sectorsTitle: 'Sectores de Intervención',
  sectorsSubtitle: 'Experiencia sectorial para un reclutamiento dirigido y eficaz',
  sector1: 'Textil & Confección',
  sector2: 'Automotriz',
  sector3: 'Agroalimentario',
  sector4: 'Logística', 
  sector5: 'Gestión Industrial',
  processTitle: 'Nuestro Proceso de Reclutamiento',
  processSubtitle: 'Un enfoque estructurado para resultados garantizados',
  process1Title: 'Análisis del Puesto',
  process1Desc: 'Definición precisa del perfil buscado, competencias requeridas y cultura empresarial',
  process2Title: 'Búsqueda & Preselección',
  process2Desc: 'Búsqueda activa y preselección de candidatos más relevantes según sus criterios',
  process3Title: 'Evaluación Técnica',
  process3Desc: 'Pruebas técnicas y puestas en situación para validar competencias operacionales',
  process4Title: 'Evaluación Comportamental',
  process4Desc: 'Análisis de soft skills y adecuación con la cultura y valores de la empresa',
  process5Title: 'Presentación Shortlist',
  process5Desc: 'Selección de mejores perfiles presentados con análisis detallado de cada candidato',
  process6Title: 'Integración & Seguimiento',
  process6Desc: 'Acompañamiento durante la integración y seguimiento post-reclutamiento para asegurar el éxito',
  closingTitle: 'Enfoque en el Rendimiento Industrial',
  closingText: 'Nuestro reclutamiento está orientado hacia la excelencia operacional y la mejora continua, garantizando colaboradores performantes y comprometidos.',
  stats: {
    talents: 'Talentos Colocados',
    successRate: 'Tasa de Éxito',
    yearsExp: 'Años Exp.',
    sectors: 'Sectores'
  },
  floatingBadge: {
    title: 'Expertos RRHH',
    subtitle: 'Especialistas Industriales'
  },
  ctaButton: 'Reclutar con nosotros'
},
    contact: {
      pageTitle: 'Contáctenos',
      pageSubtitle: 'Hablemos de sus proyectos y cómo podemos apoyarle',
      emailLabel: 'Email',
      addressLabel: 'Dirección',
      hoursLabel: 'Horarios',
      hoursValue1: 'Lunes - Viernes',
      hoursValue2: '9:00 - 18:00',
      locationTitle: 'Nuestra Ubicación',
      locationDesc: 'ESQUINA CALLE AL ARAAR Y BULEVAR LALLA YACOUT, EDIFICIO A, APARTAMENTO 8, CASABLANCA.',
      formTitle: 'Envíenos un Mensaje',
      formSubtitle: 'Complete el formulario a continuación y nos contactaremos vía WhatsApp',
      nameLabel: 'Nombre completo',
      namePlaceholder: 'Su nombre',
      emailPlaceholder: 'su.email@ejemplo.com',
      phoneLabel: 'Teléfono',
      phonePlaceholder: '+212 XXX XXX XXX',
      companyLabel: 'Empresa',
      companyPlaceholder: 'Nombre de su empresa',
      messageLabel: 'Mensaje',
      messagePlaceholder: 'Describa su proyecto o necesidades...',
      submitButton: 'Enviar vía WhatsApp',
      formNote: 'Al enviar este formulario, su información será enviada directamente a nuestro WhatsApp profesional',
      ctaTitle: '¿Listo para Iniciar su Proyecto?',
      ctaText: 'Contáctenos hoy mismo para discutir sus necesidades y descubrir cómo podemos ayudarle a alcanzar sus objetivos.',
      callButton: 'Llámenos',
      emailButton: 'Enviar un email',
      mapDescription: "Our office located in the heart of Casablanca, easily accessible"
    },
   about: {
  heroBadge: "Acerca de Nosotros",
  pageTitle: 'Texaconsult – Consultoría para la Industria Manufacturera',
  pageSubtitle: 'Experto en excelencia operacional y acompañamiento industrial',
  expertiseTitle: 'Nuestra Experiencia Sectorial',
  expertiseText1: 'Fundado por Elhoucine Laguetar, Texaconsult es una firma de consultoría especializada en excelencia operacional y acompañamiento industrial.',
  expertiseText2: 'Intervenimos en empresas manufactureras en el sector textil y de la confección, la industria automotriz y el sector agroalimentario para mejorar sus rendimientos, fortalecer sus competencias y optimizar sus procesos de producción.',
  expertiseText3: 'Gracias a un enfoque terreno, pragmático y humano, Texaconsult ayuda a sus socios a transformar sus organizaciones, reducir desperdicios y alcanzar una excelencia industrial sostenible.',
  valuesTitle: 'Nuestra Experiencia Sectorial',
  valuesSubtitle: 'Intervenciones especializadas en sectores clave de la industria manufacturera',
  value1Title: '🧵 Industria Textil y Confección',
  value1Desc: 'Mejora continua, lean manufacturing, equilibrado de líneas, formación técnica y optimización de procesos de producción textil.',
  value2Title: '🚗 Industria Automotriz',
  value2Desc: 'Optimización de métodos, calidad producto/proceso, mantenimiento industrial y rendimiento de talleres de producción automotriz.',
  value3Title: '🧃 Industria Agroalimentaria',
  value3Desc: 'Organización industrial, seguridad alimentaria, dominio de procesos y desarrollo de competencias de equipos de producción.',
  value4Title: '🏭 Excelencia Operacional',
  value4Desc: 'Transformación de organizaciones, reducción de desperdicios e implementación de sistemas de rendimiento industrial sostenible.',
  missionTitle: 'Nuestra Misión',
  missionText1: 'Acompañar a empresas manufactureras en su transformación hacia la excelencia operacional mediante soluciones concretas y adaptadas.',
  missionText2: 'Nuestro enfoque combina experiencia sectorial, metodologías probadas y acompañamiento en terreno para garantizar resultados medibles y duraderos.',
  stat1: 'Años de Experiencia',
  stat2: 'Proyectos Exitosos',
  stat3: 'Sectores de Intervención',
  stat4: 'Clientes Satisfechos',
  ctaTitle: '¿Listo para Transformar su Rendimiento Industrial?',
  ctaText: 'Descubra cómo Texaconsult puede apoyarle en la optimización de sus procesos y la mejora de su rendimiento manufacturero.',
  ctaButton: 'Contáctenos',
  clientsTitle: "Ellos Confían en Nosotros",
  clientsSubtitle: "Descubre las empresas manufactureras que nos han elegido para su excelencia operativa",
  skill1: "Mejora Continua",
  skill2: "Manufactura Esbelta",
  skill3: "Optimización de Procesos", 
  skill4: "Formación Técnica",
  expertTitle: "Experto Industrial",
  foundedBy: "Fundado por Elhoucine Laguetar",
      sectorsTitle: "Nuestros Sectores de Experiencia",
    sectorsSubtitle: "Descubre los dominios en los que destacamos",
    sectorAutomotive: "Sector Automotriz",
    sectorAgrofood: "Sector Agroalimentario",
    sectorTextil: "Sector Textil"
},
    whatsapp: {
      greeting: '¡Hola! 👋',
      message: '¿Cómo podemos ayudarle hoy?',
      startButton: 'Iniciar conversación',
      note: 'Haga clic para abrir WhatsApp y contactarnos directamente',
      online: 'En línea',
      defaultMessage: 'Hola Texaconsult, me gustaría obtener más información sobre sus servicios.'
    },
    footer: {
      description: 'Firma de Consultoría - Soluciones a medida para su rendimiento industrial.',
      quickLinks: 'Enlaces Rápidos',
      contactTitle: 'Contacto',
      copyright: 'Todos los derechos reservados.'
    }
  }
}

export const useTranslation = (language) => {
  return (key) => {
    const keys = key.split('.')
    let value = translations[language]
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k]
      } else {
        return key
      }
    }
    
    return value || key
  }
}
